import Modal from "client/common/components/deprecated-modals/Modal";
import ModalLayout from "client/common/components/deprecated-modals/ModalLayout";

import styles from "../styles/CrossSellsDisclaimerModal.module.less";

type CrossSellsDisclaimerModalProps = {
  visible: boolean;
  onClose: () => void;
};

const CrossSellsDisclaimerModal = (props: CrossSellsDisclaimerModalProps) => {
  const { visible, onClose } = props;

  return (
    <Modal visible={visible} onClose={onClose}>
      <ModalLayout>
        <ModalLayout.Header title="Frequently purchased with" onClose={onClose} />
        <ModalLayout.Content>
          <div className={styles.body}>
            The &quot;Frequently purchased with&quot; suggestions provided by this site are based
            solely on prior purchasing history and do not constitute the practice of veterinary
            medicine or pharmacy. The suggestions are not tailored to the specific needs of your pet
            and should not be relied upon as a substitute for professional veterinary advice. Any
            questions or concerns regarding the proper use of medications or the appropriate course
            of treatment for a pet should be directed to a licensed veterinarian. Our platform does
            not provide medical advice or opinion and is not responsible for decisions made by users
            based on the suggestions provided. It is the responsibility of each customer to evaluate
            the recommendations and to make their own decisions regarding the procurement and use of
            any products, in consultation with his or her veterinarian.
          </div>
        </ModalLayout.Content>
      </ModalLayout>
    </Modal>
  );
};

export default CrossSellsDisclaimerModal;
